<div class="popup-dark-view" (click)="dismiss()">
  <div class="popup-holder" id="child">
    <div class="popup-img">
      <img src="{{ inputs.img }}" />
    </div>
    <div class="popup-title">{{ inputs.title }}</div>
    <div class="popup-description">{{ inputs.description }}</div>
    <div class="popup-submit-holder">
      <div class="popup-submit" id="submit-button" (click)="confirm()">
        <div class="popup-submit-title">
          {{ inputs.button }}
        </div>
      </div>
    </div>
  </div>
</div>
